module.exports = __webpack_public_path__ + "static/img/kraft_boxes_new.8b23ab9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kraft_boxes_new.png
// module id = lmf0
// module chunks = 1